// @flow

import React, { Fragment } from 'react';
import map from 'lodash/map';
import { formatCentsToDollars } from 'clark-utils';
import { Grid, Row } from 'clark-styles';

import type { SessionType } from 'types/sessions';
import type { EngagementsType } from 'types/engagements';
import type { ClientsType } from 'types/clients';
import type { SubjectsType } from 'types/subjects';

import { Wrapper } from 'styles/table';
import SessionsListEmpty from 'components/sessions/list/empty';

import SessionRow from './row';
import TableHeader from './table-header';
import { getSessionsDataObject, orderedPastSessions } from '../helpers';

type PropsType = {
  clients: ClientsType,
  engagements: EngagementsType,
  engagementDataEmpty: boolean,
  sessions: SessionType[],
  subjects: SubjectsType,
};

const PastSessions = ({
  clients,
  engagements,
  sessions,
  engagementDataEmpty,
  subjects,
}: PropsType) => (
  <Wrapper>
    <Grid>
      {sessions.length ? (
        <Fragment>
          <TableHeader />
          {map(orderedPastSessions(sessions), session => {
            const { sessionId, sessionWageInCents } = getSessionsDataObject(clients, session);
            return (
              <SessionRow
                clients={clients}
                earnings={formatCentsToDollars(sessionWageInCents)}
                key={sessionId}
                sessionId={sessionId}
                session={session}
                subjects={subjects}
                tutoringEngagements={engagements}
              />
            );
          })}
        </Fragment>
      ) : (
        <Row>
          <SessionsListEmpty hide={engagementDataEmpty} />
        </Row>
      )}
    </Grid>
  </Wrapper>
);

export default PastSessions;



// WEBPACK FOOTER //
// ./src/components/sessions/list/past/index.js